import { Card, SxProps, Typography } from "@mui/material";
import Content from "../Layout/Content";
import { useSearchParams } from "react-router";
import { useInvoiceViewDetails } from "./useInvoiceViewDetails";
import LoadingOverlay from "../Shared/LoadingOverlay";
import InvoiceViewItem from "./InvoiceViewItem";

const invoiceCardSx: SxProps = { padding: 0 };

export default function InvoiceView() {
    const [searchParams] = useSearchParams();

    const uniqueIdentifier: string | null = searchParams.get("id");

    const { invoice, invoiceLoading } = useInvoiceViewDetails(uniqueIdentifier);
    return (
        <Content
            dataTestIdSuffix="view_invoice"
            sx={{ padding: "32px 8px 0", display: "flex", flexDirection: "column", gap: "16px" }}
        >
            <Typography variant="heading3">Your Invoice</Typography>
            {invoiceLoading ? (
                <LoadingOverlay />
            ) : invoice ? (
                <Card variant="outlined" sx={invoiceCardSx}>
                    <InvoiceViewItem invoice={invoice} />
                </Card>
            ) : null}
        </Content>
    );
}
